export default __webpack_public_path__ + "static/media/trash-on.95bf2cbc.svg";